import Vue from 'vue'
import Vuex from 'vuex'

// electron 端
// import { createPersistedState, createSharedMutations } from 'vuex-electron'

import modules from './modules'

Vue.use(Vuex)

export default new Vuex.Store({
  // modules,
  // electron 端
  // plugins: [
  //   createPersistedState(),
  //   createSharedMutations()
  // ],
  // strict: process.env.NODE_ENV !== 'production'


  //数据，相当于data
  state: {
    serchkey: ""
  },
  getters: {

  },
  //里面定义方法，操作state方发
  mutations: {

  },
  // 操作异步操作mutation
  actions: {

  },
  modules: {
  }
})
